import { useEffect, useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as PointLimitQL from "queries/point-limit";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;


export const Content = ({
  match: {
    params,
    params: { pointId },
  },
}) => {
  const [phase, setPhase] = useState("init");
  const history = useHistory();
  // The limits list under this point. replace(), not goBack(): where you
  // landed used to depend on how you reached the form.
  const { base } = useSectionContext();

  useEffect(() => {
    if (phase === "complete") {
      history.replace(base);
    }
  }, [phase]);

  const initial = {
    description: "",
    limits: [],
    dimensions: []
  };
  return (
    <Mutation
      initial={initial}
      context={{ phase }}
      target={{ $ref: "/Public/PointLimit/Create" }}
      mutation={PointLimitQL.create}
      update={PointLimitQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        setPhase("loading");

        handler({
          variables: {
            pointId,
            input: values,
          },
        });
      }}
      onCompleted={() => {
        setPhase("complete");
      }}
      onError={(error) => {
        // Without this the Create button keeps spinning, disabled, forever.
        setPhase("init");
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({
  schema,
  state,
  mutate,
  context: {
    phase,
  },
  target,
}) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: {
      "/Public/PointLimit/Create": {
        fields: [
          {
            property: "description",
            textarea: true,
          },
          "dimensions",
          "limits",
        ],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit" loading={phase === "loading"}>
                Create
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
